// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b2b-lib-check_box_group{position:relative}.b2b-lib-check_box_group .b2b-lib-checkboxContainer .b2b-lib-checkboxLabel .b2b-lib-customChecboxIcon{margin-top:var(--spacing-xs)}\n", ""]);
// Exports
exports.locals = {
	"check_box_group": "b2b-lib-check_box_group",
	"checkboxContainer": "b2b-lib-checkboxContainer",
	"checkboxLabel": "b2b-lib-checkboxLabel",
	"customChecboxIcon": "b2b-lib-customChecboxIcon"
};
module.exports = exports;
